import {Compatibility} from '../infrastructure/api/Compatibility';

export const C = new Compatibility();
